import React from "react";
import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";

// eslint-disable-next-line react/prop-types
const SingleSolution = ({ id, title, subtitle, slogan, icon }) => {
  const { t } = useTranslation();
  return (
    <div
      className={
        id <= 3
          ? "single-service-inner-3 single-service-inner-3-left"
          : "single-service-inner-3 single-service-inner-3-right"
      }
    >
      <div className="thumb">
        <div className="thumb-inner">
          <img src={icon} alt="img" />
        </div>
      </div>
      <div className="details">
        <h5 className="mb-3">
          {t(title)}
          {/* <Link to={`/solution/${id}`}></Link> */}
        </h5>
        <h6
          className="mb-0"
          dangerouslySetInnerHTML={{ __html: t(subtitle) }}
        ></h6>
        <p className="mb-0" dangerouslySetInnerHTML={{ __html: t(slogan) }}></p>
      </div>
    </div>
  );
};

export default SingleSolution;
